import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";

export const VehicleDamageReportStep4 = forwardRef(function VehicleDamageReportStep4({ onCapture, t }, ref) {
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const [cameraReady, setCameraReady] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    navigator.mediaDevices
      .getUserMedia({ video: { facingMode: "environment" } })
      .then((stream) => {
        if (!mounted) {
          stream.getTracks().forEach((t) => t.stop());
          return;
        }
        streamRef.current = stream;
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.play();
          setCameraReady(true);
        }
      })
      .catch(() => {
        if (mounted) setError(t("keylessReturnCameraError"));
      });

    return () => {
      mounted = false;
      if (streamRef.current) {
        streamRef.current.getTracks().forEach((t) => t.stop());
      }
    };
  }, []);

  useImperativeHandle(ref, () => ({
    capture: () => {
      const video = videoRef.current;
      if (!video) return;
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext("2d").drawImage(video, 0, 0);
      const dataUrl = canvas.toDataURL("image/jpeg", 0.7);
      if (streamRef.current) {
        streamRef.current.getTracks().forEach((t) => t.stop());
      }
      onCapture(dataUrl);
    },
  }), [onCapture]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        width: "100%",
        gap: "24px",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        <p
          style={{
            fontSize: "14px",
            color: "#333",
            margin: 0,
            lineHeight: "1.4",
          }}
        >
          {t("keylessReturnDamageSubmit")}
        </p>
      </div>

      {/* Área da Câmera */}
      <div
        style={{
          width: "100%",
          height: "280px",
          backgroundColor: "#E2E5E9",
          borderRadius: "16px",
          position: "relative",
          overflow: "hidden",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* Cantoneiras da Câmera (estilo foco) */}
        <div style={{ position: "absolute", top: "20px", left: "20px", width: "40px", height: "40px", borderTop: "6px solid rgba(150,150,150,0.6)", borderLeft: "6px solid rgba(150,150,150,0.6)", borderRadius: "8px 0 0 0" }}></div>
        <div style={{ position: "absolute", top: "20px", right: "20px", width: "40px", height: "40px", borderTop: "6px solid rgba(150,150,150,0.6)", borderRight: "6px solid rgba(150,150,150,0.6)", borderRadius: "0 8px 0 0" }}></div>
        <div style={{ position: "absolute", bottom: "20px", left: "20px", width: "40px", height: "40px", borderBottom: "6px solid rgba(150,150,150,0.6)", borderLeft: "6px solid rgba(150,150,150,0.6)", borderRadius: "0 0 0 8px" }}></div>
        <div style={{ position: "absolute", bottom: "20px", right: "20px", width: "40px", height: "40px", borderBottom: "6px solid rgba(150,150,150,0.6)", borderRight: "6px solid rgba(150,150,150,0.6)", borderRadius: "0 0 8px 0" }}></div>

        {error ? (
          <span style={{ color: "#c00", fontSize: "14px", zIndex: 1 }}>{error}</span>
        ) : !cameraReady ? (
          <span style={{ color: "#666", fontSize: "14px", zIndex: 1 }}>{t("keylessReturnStartingCamera")}</span>
        ) : null}

        <video
          ref={videoRef}
          playsInline
          muted
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: cameraReady ? "block" : "none",
          }}
        />
      </div>
    </div>
  );
});